import { LuxSelectablePill, LuxTypography, useTheme } from '@gemini/fe-ds-core';
import { usePatientStore } from '@store/patientStore';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { MultipatientsTagslWrapper } from './CalendarPage.styles';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

interface MultipatientsTagsProps {
  showHour?: boolean; // se true mostra ora, se false mostra data
}

const MultipatientsTags = ({ showHour = false }: MultipatientsTagsProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const getPatients = usePatientStore(state => state.getPatients);
  const patients = getPatients();
  const currentPatientIndex = useOnlineBookingStore(
    state => state.currentPatient,
  );

  return (
    <MultipatientsTagslWrapper theme={theme}>
      {patients.map(
        (patient, index) =>
          patient &&
          patient.scheduleExam &&
          index !== currentPatientIndex && (
            <LuxSelectablePill
              key={`calendar-time-slot-pill-${index}`}
              selectable={false}
              variant="pill"
              text={
                <>
                  <LuxTypography fontWeight={700} variant="textMdRegular">
                    {showHour
                      ? `${patient?.scheduleExam?.hour}`
                      : patient?.scheduleExam?.day
                        ? `${dayjs(patient.scheduleExam.day).format('D MMMM')}`
                        : 'Invalid date'}
                  </LuxTypography>
                  <LuxTypography fontWeight={400} variant="textMdRegular">
                    {patient?.patientDetails?.firstName &&
                    patient?.patientDetails?.lastName
                      ? `${patient?.patientDetails?.firstName} ${patient?.patientDetails?.lastName}'s selection`
                      : `${t('detailsSection.newPatient')}'s selection`}
                  </LuxTypography>
                </>
              }
            />
          ),
      )}
    </MultipatientsTagslWrapper>
  );
};

export default MultipatientsTags;
